import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { switchEndpoint } from "../../../../../../../../../../redux/actions/endpoints";
import { storage } from "../../../../../../../../../../scopedStorage";

const useDropOffTransaction = ({ dropOffData, onSuccessUnregistered, onSuccessRegistered }) => {
  const [loading, setLoading] = useState(false);

  const initiateTransaction = useCallback(
    async ({ wastePayload, paymentMethod, totalManual, hasErrors }) => {
      const isCorporate = dropOffData?.owner?.roles?.[0] === "corporate";
      const isUnregistered = dropOffData?.owner?.user_type === "unregistered";

      // Guard: block if any category has a kg validation error
      if (hasErrors) {
        toast.error("Please fix the invalid kg values before submitting", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
        });
        return;
      }

      // Guard: block if no categories have valid kg entered
      if (!wastePayload.length) {
        toast.error("Please enter weight for at least one category", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
        });
        return;
      }

      // Non-corporate users must pick a payment method
      if (!isCorporate && !paymentMethod) {
        toast.error("You must select a payment method", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
        });
        return;
      }

      setLoading(true);

      const token = storage.getItem("token");
      const id = localStorage.getItem("id");

      const payload = {
        waste_category: wastePayload,
        dropoff_id: id,
        // Corporate accounts always use transfer
        payment_method: isCorporate ? "transfer" : paymentMethod,
        request_type: "dropoff",
        // Only include manual_amount when it has a meaningful value
        ...(totalManual > 0 && { manual_amount: totalManual }),
      };

      try {
        const response = await axios.post(
          `${switchEndpoint}/collection-center/initiate-transaction`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        localStorage.setItem("dropOff", JSON.stringify(response.data));

        if (isUnregistered) {
          onSuccessUnregistered();
        } else {
          onSuccessRegistered(response.data);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Something went wrong", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
        });
      } finally {
        setLoading(false);
      }
    },
    [dropOffData, onSuccessUnregistered, onSuccessRegistered]
  );

  return { loading, initiateTransaction };
};

export default useDropOffTransaction;
